module.exports = __webpack_public_path__ + "static/media/apartment7.740812ea.jpg";